/** @jsxImportSource @emotion/react */

import { useState } from 'react'
import Typography from '@mui/material/Typography'
import { useLocation, useSearchParams } from 'react-router-dom'
import TabsNavigation from 'components/TabsNavigation/TabsNavigation'
import { TabsItem } from 'types/tabsItem'
import { RouteValue, useLink } from 'routes/cmsRoutes'
import { List } from '../List'
import QuestionTemplates from '../QuestionTemplates'
import * as classes from './styles'

export const QUESTIONS_TAB = {
  id: 'questions',
  title: 'Questions',
}

export const QUESTION_TEMPLATES_TAB = {
  id: 'question-templates',
  title: 'Templates',
}

export const TABS = [QUESTIONS_TAB, QUESTION_TEMPLATES_TAB]

export const QUERY_PARAM = 'tab'

export const QuestionTabs = () => {
  const location = useLocation()
  const { navigate } = useLink()
  const [searchParams] = useSearchParams()

  const [activeTab, setActiveTab] = useState<TabsItem>(() => {
    const tabId = searchParams.get(QUERY_PARAM)

    return TABS.find(({ id }) => id === tabId) || QUESTIONS_TAB
  })

  const handleChangeTab = (activeTab: TabsItem) => {
    const nextSearchParams = new URLSearchParams(searchParams)
    nextSearchParams.set(QUERY_PARAM, activeTab.id)

    navigate(location.pathname as RouteValue, undefined, {
      searchParams: nextSearchParams,
    })
    setActiveTab(activeTab)
  }

  const renderTitle = () => {
    if (activeTab.id === QUESTIONS_TAB.id) {
      return 'Questions'
    }

    if (activeTab.id === QUESTION_TEMPLATES_TAB.id) {
      return 'Modify Question Templates'
    }

    return null
  }

  const renderTab = () => {
    if (activeTab.id === QUESTIONS_TAB.id) {
      return <List />
    }

    if (activeTab.id === QUESTION_TEMPLATES_TAB.id) {
      return <QuestionTemplates />
    }

    return null
  }

  return (
    <section css={classes.container}>
      <Typography css={classes.header} variant="title3">
        {renderTitle()}
      </Typography>

      <TabsNavigation css={classes.tabs} tabs={TABS} value={activeTab} onChange={handleChangeTab} />

      {renderTab()}
    </section>
  )
}
